export const DEFAULT_ROW_LABEL_FIELD = "row_label";

/**
 * Pivots columnar data into AG Grid row-oriented format for a single table.
 *
 * @example
 * ```ts
 * const data = {
 *   "GS1|PTD": [[100, 200], [300, 400]],
 *   "GS1|PTG": [[50, 60],  [70, 80]]
 * };
 * pivotToRowData(data, 0, ["Nike", "Adidas"], "row_label");
 * // => [
 * //   { row_label: "Nike",   "GS1|PTD": 100, "GS1|PTG": 50 },
 * //   { row_label: "Adidas", "GS1|PTD": 200, "GS1|PTG": 60 },
 * // ]
 * ```
 */
export function pivotToRowData(
  data: Record<string, (number | null)[][]>,
  tableIndex: number,
  rowLabels: string[],
  rowLabelField: string = DEFAULT_ROW_LABEL_FIELD
): Record<string, unknown>[] {
  return rowLabels.map((label, rowIndex) => {
    const row: Record<string, unknown> = { [rowLabelField]: label };
    for (const [column, tables] of Object.entries(data)) {
      row[column] = tables[tableIndex]?.[rowIndex] ?? null;
    }
    return row;
  });
}
